import { useStatsOverview } from './useStatsOverview'
import type { StatsOverview } from './types'

export type { CallStats } from './types'

export function useCallStats() {
  const q = useStatsOverview()
  return { ...q, data: q.data?.calls as StatsOverview['calls'] | undefined }
}
